import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComboboxList, ComboboxPopover } from "@reach/combobox";
import { memo } from "react";
import { SEARCH_SUGGESTIONS_CONTAINER } from "~/constants/testIDs";
export const SearchSuggestions = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "h-[5px] w-[calc(100%+12px)] shadow-[0px_0px_8px_rgba(0,0,0,0.2)]"
            }),
            /*#__PURE__*/ _jsx(ComboboxPopover, {
                "data-testid": SEARCH_SUGGESTIONS_CONTAINER,
                className: "max-h-[calc(100vh-70px)] overflow-auto rounded-b-lg border-0 bg-grey-1 shadow-popover md:border-t md:border-t-grey-5",
                style: {
                    boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.2)"
                },
                children: /*#__PURE__*/ _jsx(ComboboxList, {
                    className: "p-2",
                    children: children
                })
            })
        ]
    });
});
SearchSuggestions.displayName = "SearchSuggestions";
